/** Classes partagées des formulaires du YouTube Studio (alignées sur l'admin). */
export const inputCls =
  'border-ink-200 text-ink-900 placeholder:text-ink-400 focus:ring-primary-400 w-full rounded-xl border px-3 py-2.5 font-sans text-[14px] focus:outline-none focus:ring-2';
export const labelCls = 'font-display text-ink-700 text-[12px] font-semibold';
export const sectionCls = 'border-ink-200 rounded-2xl border bg-white p-4 sm:p-5';
